import { StyledGraphMain } from '../ResourceAllocationOverview.style';
import { StyledAllocationOverTime } from './AllocationOverTime.style';
import Graph from './Graph/Graph';
import Header from './Header';
import Loader from './Loader';
import useAllocationOverTime from './useAllocationOverTime/useAllocationOverTime';
import useGraphView from './useGraphView';

const AllocationOverTime = () => {
  const {
    granularity,
    setGranularity,
    resourceType,
    setResourceType,
    data,
    epicsPercent,
    isOverlapping,
    isLoading
  } = useAllocationOverTime();

  const graphView = useGraphView({ isOverlapping });

  return (
    <StyledAllocationOverTime data-cy='allocation-over-time'>
      <Header
        granularity={granularity}
        setGranularity={setGranularity}
        resourceType={resourceType}
        setResourceType={setResourceType}
        graphView={graphView}
      />
      <StyledGraphMain>
        {isLoading ? (
          <Loader />
        ) : (
          <Graph
            data={data}
            epicsPercent={epicsPercent}
            resourceType={resourceType}
            granularity={granularity}
            graphView={graphView}
          />
        )}
      </StyledGraphMain>
    </StyledAllocationOverTime>
  );
};

export default AllocationOverTime;
